//2026/1/30 室内窓LP対応で新規作成　担当：四方
//通常スライダー（1枚表示の無限ループ）

(function () {
  'use strict';

  function initSlider(root) {

    //////////////////////////////////
    // HTMLの設定を読み込む初期化処理 // 
    //////////////////////////////////
    const track = root.querySelector('.img-slider__track');   // スライドを横並びにして動かすコンテナ
    const slides = Array.from(track.children);                // 各スライド（画像1枚分）の配列
    const prev = root.querySelector('.img-slider__prev');     // 前へボタン
    const next = root.querySelector('.img-slider__next');     // 次へボタン
    const dotsWrap = root.querySelector('.img-slider__dots'); // ドットナビゲーション全体の親要素
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.img-slider__dot')) : []; // 各ドットの配列
    // HTMLで書いているdeta属性を読み込む
    const autoplay = String(root.dataset.autoplay || 'true') === 'true';    // 自動再生（デフォルト：ON）
    const interval = parseInt(root.dataset.interval || '5000', 10);         // 切り替え間隔（デフォルト：5秒）

    let timer = null;        // 自動再生用タイマーID
    let isAnimating = false; // アニメーション（デフォルト：停止）
    let currentIndex = 0;    // どのスライドを表示しているか（初期値）


    // ✅ transitionの保険（止まらない）
    function waitTransition(callback, duration = 700) {
      let called = false;

      const done = () => {
        if (called) return;
        called = true;
        callback();
      };

      track.addEventListener('transitionend', done, { once: true });
      setTimeout(done, duration);
    }

    // ✅ 表示しているスライドに対応するドットのみactiveにする
    function updateDots() {
      // ドットの配列をindexに格納
      dots.forEach((dot, index) => {
        // 表示しているスライド番号とドットの配列が一致するもののみactiveを付ける
        dot.classList.toggle('active', index === currentIndex);
      });
    }

    // ✅ 表示しているスライドの初期配列を取得（ドットと正しく同期するため）
    function updateIndexByDOM() {
      // 表示しているスライド番号をfirstに格納
      const first = track.firstElementChild;
      // firstが初期配列何番目かを取得
      currentIndex = slides.indexOf(first);
    }


    // ✅ スライド移動処理
    function slideTo(targetIndex) {
      // アニメーション中、またはクリックしたドットと同じスライドなら何もしない
      if (isAnimating || targetIndex === currentIndex) return;

      // 自動再生停止
      stopAutoplay();

      // スライドの総枚数取得
      const total = slides.length;
      // 何枚分スライドするか
      let diff = targetIndex - currentIndex;

      // ループ補正
      // 差分が0より大きい場合「差分-スライド総枚数」、それ以外は「差分+スライド総枚数」
      if (Math.abs(diff) > total / 2) {
        diff = diff > 0 ? diff - total : diff + total;
      }

      // アニメーション開始
      isAnimating = true;

      // 何枚分スライドするか
      const moveCount = Math.abs(diff);

      // ✅ 戻る（右にスライド）
      if (diff < 0) {
        // 戻るときは事前にスライドを前に移動しておく
        for (let index = 0; index < moveCount; index++) {
          // DOM（中身の構造）並び替え（後ろのスライドを先頭に移動）
          track.insertBefore(track.lastElementChild, track.firstElementChild);
        }
        
        // アニメーションを無効化
        track.style.transition = 'none';
        // スライドする枚数分左にずらす（100*スライドする枚数）
        track.style.transform = `translateX(-${100 * moveCount}%)`;

        // 1フレーム後にアニメーション開始
        requestAnimationFrame(() => {
          // スライド開始（0.6秒かけて動いて、最後ゆっくり止まる（ease-out））
          track.style.transition = 'transform 0.6s ease-out';
          // 移動したスライドを元の位置に戻す
          track.style.transform = 'translateX(0)';
        });

      // ✅ 進む（左にスライド）
      } else {
        // スライド開始（0.6秒かけて動いて、最後ゆっくり止まる（ease-out））
        track.style.transition = 'transform 0.6s ease-out';
        // スライドする枚数分左にずらす（100*スライドする枚数）
        track.style.transform = `translateX(-${100 * moveCount}%)`;
      }

      // ✅ スライドアニメーションが終わった瞬間に実行する処理
      waitTransition(() => {
        // アニメーションを無効化
        track.style.transition = 'none';

        // ✅ 先頭のスライドをスライドする枚数分後ろに移動する
        // スライド枚数が0より大きい場合（前に進んだ時）
        if (diff > 0) {
          // 移動した枚数分繰り返す
          for (let index = 0; index < moveCount; index++) {
            // 先頭のスライドを最後に移動
            track.appendChild(track.firstElementChild);
          }
        }
        // diff < 0 （戻る）は既に前でDOM移動済みなので何もしない

        // 移動したスライドを元の位置に戻す
        track.style.transform = 'translateX(0)';

        // 今表示しているのは何枚目のスライドか再計算
        updateIndexByDOM();
        // ドット更新
        updateDots();

        // アニメーション終了
        isAnimating = false;
        // 自動再生開始
        startAutoplay();
      });
    }

    // ✅ 矢印ボタンクリック時（前へ）
    prev.addEventListener('click', () => {
      slideTo(currentIndex - 1);
    });

    // ✅ 矢印ボタンクリック時（次へ）
    next.addEventListener('click', () => {
      slideTo(currentIndex + 1);
    });

    // ✅ ドットボタンクリック時
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slideTo(index);
      });
    });

    // ✅ 自動再生 開始
    function startAutoplay() {
      // 自動再生がオフ、またはスライドが1枚以下の場合は何もしない
      if (!autoplay || slides.length <= 1) return;
      // 自動再生停止
      stopAutoplay();
      // 切り替え間隔（秒数）ごとにスライドを移動
      timer = setInterval(() => {
        slideTo(currentIndex + 1);
      }, interval);
    }

    // ✅ 自動再生 停止
    function stopAutoplay() {
      // 切り替え間隔（秒数）が設定されている場合
      if (timer) {
        // 自動再生を停止
        clearInterval(timer);
        // 切り替え間隔をリセット（初期化）
        timer = null;
      }
    }

    // ✅ マウスホバー
    // ホバー時は自動再生を停止
    root.addEventListener('mouseenter', stopAutoplay);
    // ホバーが外れたら再開
    root.addEventListener('mouseleave', startAutoplay);

    // ✅ スワイプ移動（モバイル用）
    // 開始位置を変数に格納
    let startX = 0;

    // 開始位置（指を置いた場所）のX座標を取得
    root.addEventListener('touchstart', (e) => {
      // 「e.touches[0].clientX;」＝指の位置
      startX = e.touches[0].clientX;
      // スワイプ中は自動再生停止
      stopAutoplay();
    });

    // 終了位置（指を離した場所）との差分を計算
    root.addEventListener('touchend', (e) => {
      // 差分を計算
      const diff = e.changedTouches[0].clientX - startX;

      // 50px以上動いた場合
      if (Math.abs(diff) > 50) {
        // 差分が0より大きければ逆方向スライド、それ以外は通常スライド
        slideTo(diff > 0 ? currentIndex - 1 : currentIndex + 1);
      }

      //自動再生を再開 
      startAutoplay();
    });

    //自動再生を再開 
    startAutoplay();
  }

  // ✅ ページ内の全ての「.img-slider」に対してスライドを実行
  function initAll() {
    document.querySelectorAll('.img-slider').forEach(initSlider);
  }

  // ✅ ページ内のHTMLの読み込みが完了したタイミングでスライドを実行
  document.addEventListener('DOMContentLoaded', initAll);
})();
